export default {
    GET_JOB_PRINT_COLORS: (state, data) => {
        state.jobPrintColors = data.results
    },
    GET_PRODUCT_TYPE_CONFIGURATIONS_SUCCESS: (state, data) => {
        state.productTypeConfigurations = data.results
    },

    /* GET_JOBS
    ---------------------------------------------------------------
    */
    GET_JOBS_REQUEST: state => {
        state.jobsLoading = true
    },
    GET_JOBS_SUCCESS: (state, data) => {
        state.jobs = data.results
        state.jobsLoading = false
    },
    GET_JOBS_FAILURE: state => {
        state.jobsLoading = false
    },

    /* GET_ORDER_COMPONENTS
    ---------------------------------------------------------------
    */

    GET_ORDER_COMPONENTS_REQUEST: state => {
        state.orderComponentsLoading = true
    },
    GET_ORDER_COMPONENTS_SUCCESS: (state, data) => {
        state.orderComponents = data.results
        state.orderComponentsLoading = false
    },
    GET_ORDER_COMPONENTS_FAILURE: state => {
        state.orderComponentsLoading = false
    },

    SET_JOBS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_JOBS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}